/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ------------------------------------------------------------------ */
/* VLS custom — Flèches ˄/˅ des miniatures = navigation image (prev/next) */
/* Les flèches de la bande de miniatures déclenchent le changement d'image  */
/* comme les flèches ‹ › de l'image principale, et recadrent la miniature  */
/* active. On neutralise le simple défilement de la bande pour éviter tout   */
/* désalignement entre l'image affichée et les miniatures.                   */
/* ------------------------------------------------------------------ */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.vls-gnav--thumb') : null;
    if (!btn) return;
    var gallery = btn.closest('.product-gallery');
    if (!gallery) return;
    var label = (btn.getAttribute('aria-label') || '').toLowerCase();
    var isNext = label.indexOf('suivant') !== -1;
    var arrow = gallery.querySelector(isNext ? '.vls-gnav--next' : '.vls-gnav--prev');
    if (!arrow) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    arrow.click();
  }, true);
})();

/* ------------------------------------------------------------------ */
/* VLS 28/10/2026 — Smart Search & Filter (Globo) : produits en premier */
/* L'app reconstruit le DOM à chaque requête. On remet donc la colonne      */
/* produits avant suggestions/collections après chaque rendu.               */
/* ------------------------------------------------------------------ */
(function () {
  'use strict';

  var scheduled = false;

  function reorderGloboSearch() {
    scheduled = false;

    var rows = document.querySelectorAll(
      '#glFilter-search-popup.gl-filter-search-fullscreen .gl-fullscreen-initial-content > .gl-row'
    );

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var products = row.querySelector(':scope > .gl-col-right');
      var suggestions = row.querySelector(':scope > .gl-col-left');

      if (products && suggestions && products.nextElementSibling !== suggestions) {
        row.insertBefore(products, suggestions);
      }
    }
  }

  function scheduleGloboSearchOrder() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(reorderGloboSearch, 0);
  }

  function bootGloboSearchOrder() {
    reorderGloboSearch();
    try {
      new MutationObserver(scheduleGloboSearchOrder).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    } catch (e) {}
  }

  if (document.readyState !== 'loading') bootGloboSearchOrder();
  else document.addEventListener('DOMContentLoaded', bootGloboSearchOrder);
})();

/* ------------------------------------------------------------------ */
/* VLS 12/10/2026 (Isma) — icônes explicatives sur le configurateur frigo  */
/* (evs-fridgecfg). Décore les chips selon data-v : nouvelle install = +,  */
/* remplacement = 2 flèches circulaires, place = règle, volume = cube,     */
/* personnes = silhouettes, voyages = calendriers / route.                 */
/* S'appuie sur les classes CSS existantes (.evs-cx__chip--ic/.evs-cx__vi).*/
/* ------------------------------------------------------------------ */
(function () {
  'use strict';
  var SVGH = '<svg viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" aria-hidden="true">';
  var CXIC = {
    'new': SVGH + '<path d="M12 5v14M5 12h14"/></svg>',
    'rep': SVGH + '<path d="M20 11a8 8 0 0 0-13.7-4.5L3 9.5"/><path d="M3 4.5v5h5"/><path d="M4 13a8 8 0 0 0 13.7 4.5L21 14.5"/><path d="M21 19.5v-5h-5"/></svg>',
    'space': SVGH + '<rect x="2.5" y="8" width="19" height="8" rx="1.5"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>',
    'vol': SVGH + '<path d="M12 3 4 7.5v9L12 21l8-4.5v-9z"/><path d="M4 7.5 12 12l8-4.5M12 12v9"/></svg>',
    'both': SVGH + '<rect x="3" y="4" width="11" height="9" rx="1.5"/><rect x="10" y="11" width="11" height="9" rx="1.5"/></svg>',
    'p12': SVGH + '<circle cx="8" cy="8.5" r="3"/><path d="M2.5 19c0-3 2.4-5 5.5-5s5.5 2 5.5 5"/><circle cx="17.5" cy="9.5" r="2.3"/><path d="M15.6 19c0-2.4 1.3-4.2 3.4-4.4"/></svg>',
    'p34': SVGH + '<circle cx="6" cy="9.5" r="2.2"/><circle cx="12" cy="8" r="2.6"/><circle cx="18" cy="9.5" r="2.2"/><path d="M2.5 18.5c0-2.2 1.3-3.6 3.5-3.6M7 18.5c0-2.8 2-4.6 5-4.6s5 1.8 5 4.6M18 14.9c2.2 0 3.5 1.4 3.5 3.6"/></svg>',
    'wk': SVGH + '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 9.5h18M8 3v4M16 3v4"/><rect x="14.5" y="13" width="4" height="4" rx="0.6"/></svg>',
    'week': SVGH + '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 9.5h18M8 3v4M16 3v4M6.5 14h11"/></svg>',
    'long': SVGH + '<path d="M5 21 9.6 3M19 21 14.4 3"/><path d="M11.4 7h1.8M10.8 12h2.4M10.2 17h3.2"/></svg>'
  };
  function decorate(scope) {
    var btns = (scope || document).querySelectorAll('.evs-cx__chip[data-v]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i], ic = CXIC[b.getAttribute('data-v')];
      if (!ic || b.querySelector('.evs-cx__vi')) continue;
      b.classList.add('evs-cx__chip--ic');
      var s = document.createElement('span');
      s.className = 'evs-cx__vi';
      s.innerHTML = ic;
      b.insertBefore(s, b.firstChild);
    }
  }
  var scheduled = false;
  function schedule() { if (scheduled) return; scheduled = true; (window.requestAnimationFrame || window.setTimeout)(function () { scheduled = false; decorate(document); }, 0); }
  function boot() {
    var target = document.querySelector('[data-fq-body]') || document.querySelector('.evs-cx');
    if (!target) return; // pas de configurateur frigo sur cette page
    decorate(document);
    try { new MutationObserver(schedule).observe(target, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
